module.exports = __webpack_public_path__ + "fonts/NoirPro-Regular.752c13e1.eot";